import { render, staticRenderFns } from "./chooseRoof.vue?vue&type=template&id=2ecc9d79&scoped=true"
import script from "./chooseRoof.vue?vue&type=script&lang=js"
export * from "./chooseRoof.vue?vue&type=script&lang=js"
import style0 from "./chooseRoof.vue?vue&type=style&index=0&id=2ecc9d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc9d79",
  null
  
)

export default component.exports